export default class OrganizationType {
    code: string;

    name: string;

    description: string;

    constructor(_code: string,
      _name: string,
      _description: string) {
      this.code = _code;
      this.name = _name;
      this.description = _description;
    }

    static readonly collegeType = new OrganizationType('college', 'College', '');

    static readonly instituteType = new OrganizationType('institute', 'Institute', '');

    static readonly schoolType = new OrganizationType('school', 'School', '');

    static readonly companyType = new OrganizationType('company', 'Company', '');
  
    static readonly upDateType = new OrganizationType('company', 'Company', '');

    static allOrgTypes() {
      return [
        OrganizationType.instituteType,
        OrganizationType.companyType,
        OrganizationType.collegeType,
        OrganizationType.schoolType,
      ];
    }
}
